
/* 
  Deletes a snapshot from S3 and clears the associated data from local storage
  < input = selectedFile >
*/

export async function deleteSnapshot(S3, fileName) {
  
  // S3 bucket and csv key (prefix and filename)
  const bucket = process.env.REACT_APP_S3_BUCKET;
  const csvKey =
    localStorage.getItem("s3Link") +
    "/Forms/Snapshots/" +
    fileName +
    ".csv";

  try {
    // Delete the CSV file from S3
    await S3.deleteObject({
      Bucket: bucket,
      Key: csvKey,
    }).promise();

    // The deletion was successful if no error was thrown
    // Console Testing
    console.log("Snapshot deleted successfully");
  } catch (error) {
    console.error("Error deleting snapshot:", error);
  }
}
